import {Component, OnInit} from '@angular/core';
import {BehaviorSubject} from "rxjs";
import {Brand} from "../../../../models/Brand";
import {ApiService} from "../../../../services/api.service";
import {NzModalRef} from "ng-zorro-antd/modal";

@Component({
  selector: 'app-search-brand',
  templateUrl: './search-brand.component.html',
  styleUrls: ['./search-brand.component.scss']
})
export class SearchBrandComponent implements OnInit {

  brands: BehaviorSubject<Brand[]> = new BehaviorSubject<Brand[]>([]);
  loading$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);

  constructor(private api: ApiService, public modal: NzModalRef) {
  }

  ngOnInit(): void {
    this.getBrands();
  }

  selectBrand(brand: Brand){
    this.modal.close(brand);
  }

  getBrands(): void{
    this.api.apiGet('core/brands/active').then((BrandsData) => {
      this.brands.next(BrandsData);
      this.loading$.next(false);
    }).catch((BrandGetError) => {
      console.log('BRAND GET ERROR');
      console.log(BrandGetError);
    });
  }

  destroyModal(): void {
    this.modal.destroy();
  }

}
